import { useMemo, useState } from 'react'
import { respostasVazias } from '../../shared/respostas.util'

const INITIAL_STATE = {
  respostas: respostasVazias(),
}

export default function useModalPreviewChecklist() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      onRespostasChange(atualizar) {
        setState(prev => ({ ...prev, respostas: atualizar(prev.respostas) }))
      },
    }
  }, [])

  return { state, localDispatch }
}
